import React from 'react';

import { cn } from '../../lib/utils';

/**
 * L'afficheur de pompe (programme Stations) : les chiffres entiers sur fond
 * sombre, la décimale sur fond orange, comme le compteur que le gérant lit
 * sur le pistolet. Sert aux index de pistolet et aux montants à recopier.
 *
 *  - `value`    : nombre (ou texte numérique) ; vide → « — » ;
 *  - `decimals` : nombre de décimales affichées dans la case orange (0 = aucune) ;
 *  - `size`     : 'sm' | 'md' | 'lg' ;
 *  - `input`    : liseré orange de la valeur à saisir ;
 *  - `unit`     : unité en petit à droite (« L », « cm »).
 */
const ESPACE_FINE = ' ';

const grouper = (entier) => entier.replace(/\B(?=(\d{3})+(?!\d))/g, ESPACE_FINE);

const TAILLES = {
  sm: 'text-xs',
  md: 'text-sm',
  lg: 'text-2xl p-1',
};

export const Readout = ({ value, decimals = 1, size = 'md', input = false, unit, label, className }) => {
  const nombre = value === null || value === undefined || value === '' ? NaN : Number(value);
  const valide = Number.isFinite(nombre);
  const [entier, fraction] = valide ? Math.abs(nombre).toFixed(decimals).split('.') : ['—', ''];
  const signe = valide && nombre < 0 ? '−' : '';
  const lu = valide ? `${signe}${grouper(entier)}${fraction ? `,${fraction}` : ''}` : '—';
  return (
    <span
      className={cn(
        'inline-flex items-stretch gap-0.5 whitespace-nowrap rounded-md bg-readout p-0.5 font-mono font-semibold tabular-nums tracking-wide text-readout-foreground',
        TAILLES[size] || TAILLES.md,
        input && 'outline outline-2 outline-offset-1 outline-flame',
        className,
      )}
      aria-label={label ? `${label} : ${lu}${unit ? ` ${unit}` : ''}` : undefined}
      title={label || undefined}
    >
      <span className={cn('rounded-sm bg-readout-grid/60 px-1.5', size === 'lg' && 'px-2')}>
        {valide ? `${signe}${grouper(entier)}` : '—'}
      </span>
      {valide && decimals > 0 && (
        <span className={cn('rounded-sm bg-flame/90 px-1.5 text-white', size === 'lg' && 'px-2')}>{fraction}</span>
      )}
      {unit && <span className="self-center px-1 text-[0.75em] font-medium text-readout-foreground/70">{unit}</span>}
    </span>
  );
};

export default Readout;
